// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__2gYS8","animation":"loading_animation__2nYiW","message":"loading_message__39sWN"};